import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SugargooGuide from "@/pages/article/page";
import SugargooReview from "@/pages/article/review";
import SugargooShipping from "@/pages/article/shipping";
import SugargooCoupon from "@/pages/article/coupon";
import SugargooLegit from "@/pages/article/legit";
import SugargooWarehouse from "@/pages/article/warehouse";
import SugargooBestFinds from "@/pages/article/best-finds";
import SugargooBuyingGuide from "@/pages/article/buying-guide";
import SugargooQualityCheck from "@/pages/article/quality-check";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <SugargooGuide />,
  },
  {
    path: "/sugargoo-review",
    element: <SugargooReview />,
  },
  {
    path: "/sugargoo-shipping-cost",
    element: <SugargooShipping />,
  },
  {
    path: "/sugargoo-coupon",
    element: <SugargooCoupon />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <SugargooLegit />,
  },
  {
    path: "/sugargoo-warehouse",
    element: <SugargooWarehouse />,
  },
  {
    path: "/sugargoo-best-finds",
    element: <SugargooBestFinds />,
  },
  {
    path: "/sugargoo-buying-guide",
    element: <SugargooBuyingGuide />,
  },
  {
    path: "/sugargoo-quality-check",
    element: <SugargooQualityCheck />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;